import resendAccessCodeData from "@logic/profile/resendAccessCode";

export default {
    data: () => ({
        loading: false,
        code: "",
        parkId: 0,
        successUnlock: false,
        form: {
            email: "",
        },
    }),
    computed: {
        //Computo para obtener el total de albumes agregados al carrito
        userLoggedIn: {
            get: function () {
                return this.$store.getters.userLoggedIn;
            },
        },
    },
    methods: {
        /**
         * Metodo para cerrar la sesion del usuario
         */
        logout() {
            this.RenderParksComponent = true;
            this.$store.dispatch("setLogout");
            this.modalLogout = false;

            if (this.$route.name != "home")
                this.$router.replace({ name: "home" });
        },
        /**
         * Metodo para activar la cuenta del usuario
         */
        activateUserAccountCreated() {
            this.loading = true;
            this.errorLogin.statusApiMessage = false;
            // POST request using axios
            let $errorEmail, $errorPassword;
            axios
                .post(
                    this.pathname + "api/changePasswordUser",
                    this.formResetPassword
                )
                .then((response) => {
                    if (this.errorFormInput(response.data, "status")) {
                        //Elemento que recupera todos los error
                        this.responseErrors = response.data.errors;

                        Object.entries(this.responseErrors).forEach(
                            ([key, value]) => {
                                this.validFieldsRegister(this.responseErrors);
                            }
                        );
                    } else {
                        this.errorLogin.email = false;
                        this.errorLogin.Code = false;

                        if (this.errorFormInput(response.data, "SUCCESS")) {
                            if (this.errorFormInput(response.data, "SUCCESS")) {
                                if (response.data.SUCCESS == "true") {
                                    Vue.$toast.open({
                                        message: response.data.MESSAGE,
                                        type: "success",
                                    });

                                    this.$router.push({ name: "login" });
                                } else {
                                    Vue.$toast.open({
                                        message: response.data.MESSAGE,
                                        type: "error",
                                    });
                                }
                            }
                        }
                    }
                    //se settea el loadign para desaactivarlo
                    this.loading = false;
                })
                .catch(function (error) {
                    Vue.$toast.open({
                        message: $t("Forms.try_catch_api"),
                        type: "error",
                    });
                    //se settea el loadign para desaactivarlo
                    this.loading = false;
                });
        },
        /**
         * Metodo para loguear al usuario
         * @param status
         */
        setUserLoggedIn(status) {
            return this.$store.dispatch("setUserLoggedIn", status);
        },
        /**
         * Metodo para reenviar el codigo de acceso
         * @param email
         */
        async resendAccessCode(email = null) {
            try {
                this.$store.dispatch("setLoading", true);
                let email = email || this.form?.email;
                let { data } = await resendAccessCodeData.post({
                    Username: this.getUser?.Email,
                });
                if (data?.SUCCESS == "false") {
                    Vue.$toast.open({
                        message: this.$t("Forms.try_catch_api"),
                        type: "error",
                    });
                    return;
                }

                Vue.$toast.open({
                    message: this.$t("Forms.resend_access_code"),
                    type: "success",
                });

            } catch (error) {
                Vue.$toast.open({
                    message: this.$t("Forms.try_catch_api"),
                    type: "error",
                });
            } finally {
                this.$store.dispatch("setLoading", false);
            }
        },
    },
};
